<template>
  <b-row class="d-flex flex-nowrap wrapper float-right aside">
    <b-col class="px-0 ">
      <b-btn @click="open = !open" class="m-0 pb-5 mr-0 pl-4 btn-collapse">
        <font-awesome-icon icon="bars"/>
      </b-btn>
    </b-col>
    <div id="collapse3" class="sidebar-nav" :class="'collapse-' + open">
<!--      <b-btn v-b-toggle.collapse3 class="d-block d-lg-none collapse-xs">-->
<!--        <font-awesome-icon icon="times"/>-->
<!--      </b-btn>-->
      <b-nav class="px-0 py-5">
        <b-nav-item class="sidebar-item px-4" @click="eventClick(2)">
          <strong>{{ 'home.home' | translate }}</strong>
        </b-nav-item>
        <b-nav-item class="sidebar-item px-4" @click="eventClick(1)" :class="{'active': getSectionCurrent(1)}">
          <strong>{{ 'home.services' | translate }}</strong>
        </b-nav-item>
        <b-nav-item class="sidebar-item px-4" @click="eventClick(0)" :class="{'active': getSectionCurrent(0)}">
          <strong>{{ 'home.about_us' | translate }}</strong>
        </b-nav-item>
        <b-nav-item class="sidebar-item px-4" @click="eventClick(4)" :class="{'active': getSectionCurrent(6)}">
          <strong>{{ 'home.contact' | translate }}</strong>
        </b-nav-item>
        <b-nav-item class="sidebar-item px-4" :class="{'active': getSectionCurrent(3)}" href="https://blog.grupoapok.com/" target="_blank">
          <strong>{{ 'home.blog' | translate }}</strong>
        </b-nav-item>
        <div class="footerDiv mt-auto d-lg-none">
          <p class="descriptionBar text-right bot"><slot name="footer"/></p>
          <social-icons/>
        </div>
        <img class="pluma" alt="pluma" src="../assets/images/home/apokPluma.png"/>
      </b-nav>
    </div>
  </b-row>
</template>

<script>
  import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
  import SocialIcons from '../components/SocialIcons'

  export default {
    name: 'sidebar',
    components: { FontAwesomeIcon, FontAwesomeLayers, SocialIcons },
    data () {
      return {
        routes: ['about-us', 'services', 'portfolio', 'solutions', 'blog', 'contact'],
        routeCurrent: 0,
        open: false,
      }
    },
    methods: {
      getSectionCurrent: function (item) {
        if (this.$route.path === `/${this.routes[item]}`) {
          return true
        } else if (this.$route.matched[1] && this.$route.matched[1].parent.path === `/${this.routes[item]}`) {
          return true
        }
        return false
      },
      eventClick: function (item) {
        this.open = false
        if (item === 1) {
          this.$emit('navEvent', 0)
          this.$router.push({name: 'Services'})
          location.href = '#services'
        }
        if (item === 0) {
          this.$emit('navEvent', 1)
          this.$router.push({name: 'AboutUs'})
          location.href = '#history'
        }
        if (item === 2) {
          this.$router.push({name: 'Home'})
        }
        if (item === 4) {
          this.$emit('navEvent', 2)
          this.$router.push({name: 'Contact'})
          location.href = '#info'
        }
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../assets/styles/colors.scss';

  .aside{
    position: absolute;
    right: 30px;
    top: 0px;
    z-index: 99999;

    .collapsing {
      position: relative;
      width: 0;
      overflow: hidden;
      transition: all .2s ease;
    }
    .btn-collapse{
      background-color: transparent;
      background-image: url("../assets/images/home/rectangleMenu2.png");
      background-repeat:no-repeat;
      background-size: cover;
      border: none !important;
      color: white;
      font-size: 21px;
      padding-top: 65px;
      position: sticky;
      &:hover, &:focus, &:active{
        //background: none;
        border: none;
        box-shadow: none;
        background-color: transparent;
        border-color: transparent;
      }
    }

    .sidebar-nav{
      //position: fixed;
      right: 0;
      z-index: 1;
      transition: all 0.2s;
      .collapse-xs{
        background: none;
        border: none;
        opacity: 0.8;
        position: absolute;
        right: 0;
      }
      .nav{
        background-image: linear-gradient(to right, #00839E, #005F73);
        background-color: $dark-blue-3;
        //box-shadow: 0 0px 20px 0px rgba(0, 0, 0, 0.5);
        display: block !important;
        height: 100vh;
        position: relative;

        .nav-item{
          .nav-link{
            color: $white;
          }
          &.socials{
            border-top: 1px solid $light-blue;
            position: relative;
            top: 30vh;

            .fa-layers{
              color: $dark-blue-3;
              .circle{
                color: $dark-blue-4;
              }
              &:hover{
                color: $white;
              }
            }
          }
          &.sidebar-item{
            transition: all 0.1s;
            &:hover, &:focus, &:active{
              background-color: #60BDC5;
              a{
                color: #155a74;
              }
            }
          }
          &.active{
            background-color: #368eb1;
            a{
              color: #155a74;
            }
          }
        }
      }
    }

    .pluma{
      height: 72px;
      position: absolute;
      bottom: 7%;
      right: 10%;
      opacity: .35;
    }

    @keyframes collapsing-sidebar {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0.8;
      }

      100% {
        opacity: 0;
      }
    }
  }

  #collapse3 {
    overflow: hidden;
    &.collapse-true {
      width: 8.3vw;
      min-width: 155px;
    }
    &.collapse-false {
      width: 0px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Sidebar.vue